import React from "react";
import katex from "katex";

export const MathInline = ({ children }) => {
  const html = katex.renderToString(String(children || ""), {
    throwOnError: false,
    displayMode: false,
  });
  return <span data-testid="math-inline" dangerouslySetInnerHTML={{ __html: html }} />;
};

export const MathBlock = ({ children }) => {
  const html = katex.renderToString(String(children || ""), {
    throwOnError: false,
    displayMode: true,
  });
  return (
    <div className="math-box" data-testid="math-block" dangerouslySetInnerHTML={{ __html: html }} />
  );
};

const renderInline = (seg) =>
  katex.renderToString(String(seg || ""), { throwOnError: false, displayMode: false });

export const RichText = ({ children, className }) => {
  const parts = String(children || "").split(/\$([^$]+)\$/g);
  return (
    <p className={className}>
      {parts.map((seg, i) =>
        i % 2 === 1 ? (
          <span key={i} dangerouslySetInnerHTML={{ __html: renderInline(seg) }} />
        ) : (
          <React.Fragment key={i}>{seg}</React.Fragment>
        )
      )}
    </p>
  );
};
